import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-grid o-grid--align-middle u-mar-t-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_tarifauswahl_eine_linie = _resolveComponent("tarifauswahl-eine-linie")!
  const _component_leistungstabelle_eine_linie = _resolveComponent("leistungstabelle-eine-linie")!
  const _component_produktmodul = _resolveComponent("produktmodul")!
  const _component_hug_rabatt = _resolveComponent("hug-rabatt")!
  const _component_maklerrabatt = _resolveComponent("maklerrabatt")!
  const _component_beitrag = _resolveComponent("beitrag")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 1,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_tarifauswahl_eine_linie, { produktbezeichnung: "Bauleistung" }),
      _createVNode(_component_leistungstabelle_eine_linie, {
        inhalt: _ctx.leistungen,
        link: _ctx.tib
      }, null, 8, ["inhalt", "link"]),
      _createVNode(_component_produktmodul, {
        produktmodule: _ctx.produktmodule,
        "zeige-icons": true
      }, null, 8, ["produktmodule"]),
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Rabatte")
        ], -1)),
        _createVNode(_component_hug_rabatt)
      ]),
      _createVNode(_component_maklerrabatt, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_beitrag, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "bl",
        "tracking-zusatz": "tarif"
      })
    ])
  ], 64))
}